import { initSelectTaxa } from "./SelectTaxa";
import { initSelectCollectors } from "./SelectCollectors";
import { initCatalogNumber } from './CatalogNumberInput';

initSelectTaxa('select-taxa');

initSelectCollectors('select-collectors');

initCatalogNumber('catalog-number-container');
